export const initialRef = "CARCLOUD";
export const listedRefs = ["IYA", "CFIN"];
export const SUPPORTED_REFS = [...initialRef, ...listedRefs];

export const listedQuickWidgetRefs = ["reach", "carcloud"];
export const financeDrawWidgetRefs = ["reach", "carcloud"];
